import { Cluster, MarkerClusterer } from '@googlemaps/markerclusterer';
import type { ElevatorGroup } from 'modules/entities/modules/elevators';

import { MARKER_TYPES } from '../types';
import { getElevatorClusterState } from './colorPriority';
import { createInfoWindow } from './infoWindow';

interface MarkerLabel extends Omit<google.maps.MarkerLabel, 'text' | 'color'> {}

const renderCluster = (map: google.maps.Map, label: MarkerLabel) => (cluster: Cluster): google.maps.Marker => {
    // Get elevators sum by markers label text
    const elevatorsSum = cluster.markers.reduce((sum, marker) => {
        const googleMarker = marker as google.maps.Marker;
        const markerLabel = googleMarker.getLabel ? googleMarker.getLabel() : null;
        const labelText = typeof markerLabel === 'string' ? markerLabel : markerLabel?.text;
        return sum + Number(labelText || 0);
    }, 0);

    const elevatorClusterState = getElevatorClusterState(cluster);

    return new google.maps.Marker({
        position: cluster.position,
        map,
        label: {
            ...label,
            text: elevatorsSum.toString(),
            color: MARKER_TYPES[elevatorClusterState].labelColor,
            fontFamily:'WorkSans'
        },
        icon: MARKER_TYPES[elevatorClusterState].clusterIcon,
    });
};

export const createCluster = (
    map: google.maps.Map,
    markers: google.maps.Marker[],
    getInfoWindowOptions: (props: ElevatorGroup[]) => google.maps.InfoWindowOptions,
    label: MarkerLabel,
) => {
    const markerCluster = new MarkerClusterer({
        map,
        markers,
        renderer: { render: renderCluster(map, label) },
    });

    const { onClusterClick } = createInfoWindow(map, markerCluster, { cluster: getInfoWindowOptions });

    markerCluster.onClusterClick = onClusterClick;

    return markerCluster;
};
